import { Component, ChangeDetectionStrategy, output, input, HostListener, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-calendar-view-select',
    imports: [CommonModule],
    templateUrl: './calendar-view-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarViewSelectComponent {
  private elementRef = inject(ElementRef);
  
  viewChange = output<string>();
  currentView = input<string>('dayGridMonth');

  isOpen = false;
  
  options = [
    { label: 'Month', value: 'dayGridMonth' },
    { label: 'Week', value: 'timeGridWeek' },
    { label: 'Day', value: 'timeGridDay' },
    { label: 'Week List', value: 'listWeek' },
  ];

  getDisplayLabel() {
    return this.options.find(opt => opt.value === this.currentView())?.label || 'Month';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(value: string) {
    this.viewChange.emit(value);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
